import { takeLatest } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getReferredCustomers } from '../api';

export default function* saga() {
  yield takeLatest(types.GET_CUSTOMERS_LIST, getPaginatedListSaga(actions, getReferredCustomers));
}
